import React, {useState} from 'react';
import Linker from '../../linker/Linker';
import * as path from '../../../../route/PathConfig';
import Modal from 'react-bootstrap/esm/Modal';

import './HomeNoticeTab.css';

const VideoModal = (props) => {
  return (
    <Modal size="lg" style={{zIndex:'90000'}} show={props.show} onHide={props.handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>
          Buzzword Practical Training
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          {/* <video width="720" height="486" controls autoPlay> */}
          <video width="765" height="490" controls autoPlay>
            <source src="/files/buzzword_practical_training.mp4" type='video/mp4'></source>
          </video>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <a className="button purple" onClick={props.handleClose}>닫기</a>
      </Modal.Footer>
    </Modal>
  )
}

const getSummary = (content) => {
  let summary = content;
  if(summary.length > 30) {
    summary = summary.substr(0, 30) + "...";
  }
  return summary;
}
const HomeNoticeTab = (props) => {
  const noticeTabContents = props.noticeTabContents;
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <div className="parbase badgea">
        <div className="span4">
          <div className="mainTitle nielsen-navyBlack">NOTICE
            <div className="noticeRight">
              <a onClick={handleShow} className="button purple_line" >가이드 영상 보기</a>
              <VideoModal show={show} handleClose={handleClose} />
              <a onClick={props.handleViewMoreNotice} className="button purple_line" >더보기</a>
            </div>
          </div>
          <div className="noticeList" style={{marginTop:"58px"}} >
            <ul className="noticeList">
              {noticeTabContents.map((item) => {
               return(
                 <li>
                   <Linker path={`${path.NOTICEPAGE}/${item.noticeID}`}>
                     <a>{getSummary(item.title)}</a>
                     <span className="noticeDate">
                       {item.updatedTime}
                     </span>
                   </Linker>
                 </li>
               )
             })}
            </ul>
          </div>
        </div>
      </div>
    </>
  )
  // return (
  //   <>
  //     <div id="noticeBox">
  //       <div className="noticeTit">
  //         <div className="notice">공지사항</div>
  //         <a onClick={props.handleViewMoreNotice} className="more">더보기</a>
  //       </div>
  //       <div className="noticeList">
  //         <ul className="noticeList">
  //           {noticeTabContents.map((item) => {
  //             return(
  //               <li>
  //                 <Linker path={`${path.NOTICEPAGE}/${item.noticeID}`}>
  //                   <a>{item.title}</a>
  //                   <span className="noticeDate">
  //                     {item.updatedTime}
  //                   </span>
  //                 </Linker>
  //               </li>
  //             )
  //           })}
  //         </ul>
  //       </div>
  //     </div>
  //   </>
  // )
}

export default HomeNoticeTab;